<modal #modal [modalTitle]="title" [confirmMode]="true" primaryBtnTextKey="Submit" secondaryBtnTextKey="Cancel"
    [displayLaunchButton]="false" [loadingIndicator]="false" (secondaryClick)="resetModal()"
    (onCompleteAction)="resetModal()" (primaryClick)="submit()">
    <div>
        {{text}}
    </div>
</modal>